export { setFeatures, setMvtParams } from "./actions";
import { SET_FEATURES, SET_MVT_PARAMS } from "./constants";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FEATURES:
      return {
        ...state,
        ...action.payload
      };
    case SET_MVT_PARAMS:
      return {
        ...state,
        mvtParams: action.payload
      };
    default:
      return state;
  }
};
